import {
  GET_USER,
  GET_USER_FAIL,
  GET_USER_SUCCESS,
  GET_USER_DETAILS,
  GET_USER_DETAILS_FAIL,
  GET_USER_DETAILS_SUCCESS,
  ADD_NEW_USER,
  ADD_USER_SUCCESS,
  ADD_USER_FAIL,
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,
  EXPORT_USER_EXCEL,
  EXPORT_USER_EXCEL_SUCCESS,
  EXPORT_USER_EXCEL_FAIL,
  RESET_USER_STATE,
  RESET_USER_ACTION_STATE,
  UPDATE_ACTIVATION_USER,
  UPDATE_ACTIVATION_USER_SUCCESS,
  UPDATE_ACTIVATION_USER_FAIL,
  UPDATE_DEPARTMENT_USER,
  UPDATE_DEPARTMENT_USER_SUCCESS,
  UPDATE_DEPARTMENT_USER_FAIL,
} from "./actionTypes";

export const getUser = user => ({
  type: GET_USER,
  payload: user,
});

export const getUserSuccess = user => ({
  type: GET_USER_SUCCESS,
  payload: user,
});

export const getUserFail = error => ({
  type: GET_USER_FAIL,
  payload: error,
});

export const getUserDetails = (data) => ({
  type: GET_USER_DETAILS,
  payload: data,
});

export const getUserDetailsSuccess = user => ({
  type: GET_USER_DETAILS_SUCCESS,
  payload: user,
});

export const getUserDetailsFail = error => ({
  type: GET_USER_DETAILS_FAIL,
  payload: error,
});

//add 
export const addNewUser = user => ({
  type: ADD_NEW_USER,
  payload: user,
});

export const addUserSuccess = user => ({
  type: ADD_USER_SUCCESS,
  payload: user,
});

export const addUserFail = error => ({
  type: ADD_USER_FAIL,
  payload: error,
});

//update 
export const updateUser = (data) => ({
  type: UPDATE_USER,
  payload: data,
});

export const updateUserSuccess = user => ({
  type: UPDATE_USER_SUCCESS,
  payload: user,
});

export const updateUserFail = error => ({
  type: UPDATE_USER_FAIL,
  payload: error,
});

//update activation
export const updateActivationUser = (data) => ({
  type: UPDATE_ACTIVATION_USER,
  payload: data,
});

export const updateActivationUserSuccess = user => ({
  type: UPDATE_ACTIVATION_USER_SUCCESS,
  payload: user,
});

export const updateActivationUserFail = error => ({
  type: UPDATE_ACTIVATION_USER_FAIL,
  payload: error,
});

//update department
export const updateDepartmentUser = data => (
  {
  type: UPDATE_DEPARTMENT_USER,
  payload: data,
});

export const updateDepartmentUserSuccess = user => (
  {
  type: UPDATE_DEPARTMENT_USER_SUCCESS,
  payload: user,
});

export const updateDepartmentUserFail = error => ({
  type: UPDATE_DEPARTMENT_USER_FAIL,
  payload: error,
});

//delete 
export const deleteUser = (user) => ({
  type: DELETE_USER,
  payload: user,
});

export const deleteUserSuccess = user => ({
  type: DELETE_USER_SUCCESS,
  payload: user,
});

export const deleteUserFail = error => ({
  type: DELETE_USER_FAIL,
  payload: error,
});


//exprt excel
export const exportUserExcel = user => ({
  type: EXPORT_USER_EXCEL,
  payload: user,
});

export const exportUserExcelSuccess = user => ({
  type: EXPORT_USER_EXCEL_SUCCESS,
  payload: user,
});

export const exportUserExcelFail = error => ({
  type: EXPORT_USER_EXCEL_FAIL,
  payload: error,
});



//reset
export const resetUserState = () => {
  return {
    type: RESET_USER_STATE,
  }
}

//reset attachment
export const resetUserActionState = () => {
  return {
    type: RESET_USER_ACTION_STATE,
  }
}

